const STORAGE_KEY = 'odoo_iframe_secret';
const PARAM_NAME = 'iframe_secret';

function readHashParams() {
    const rawHash = window.location.hash.startsWith('#')
        ? window.location.hash.slice(1)
        : window.location.hash;
    return new URLSearchParams(rawHash);
}

/**
 * Lee el secreto compartido desde fragmento, query string o sessionStorage.
 * El fragmento no viaja a Nginx/PM2 ni forma parte del encabezado Referer.
 * Tras persistirlo, limpia la URL visible sin recargar la aplicación.
 */
export function getIframeSecret() {
    if (typeof window === 'undefined') return null;

    const url = new URL(window.location.href);
    const hashParams = readHashParams();
    const querySecret = url.searchParams.get(PARAM_NAME);
    const hashSecret = hashParams.get(PARAM_NAME);
    const storedSecret = window.sessionStorage.getItem(STORAGE_KEY);
    const secret = querySecret || hashSecret || storedSecret;

    if (!secret) return null;

    window.sessionStorage.setItem(STORAGE_KEY, secret);

    if (querySecret || hashSecret) {
        url.searchParams.delete(PARAM_NAME);
        hashParams.delete(PARAM_NAME);
        const remainingHash = hashParams.toString();
        const cleanLocation = `${url.pathname}${url.search}${remainingHash ? `#${remainingHash}` : ''}`;
        window.history.replaceState(window.history.state, '', cleanLocation);
    }

    return secret;
}
